<template>
  <div class="customer">
    <cc-loading-box class="loading-box" :isLoading="isLoading"></cc-loading-box>
    <div class="oprAndBrand">
      <Modal v-model="isOprShow" width="500px" :closable="false" :maskClosable="false">
        <div slot="header" class="choose-modal-title">请选择运营商</div>
        <ul>
          <li class="item" :class="oprIndex === index ? 'checked':''" v-for="(item,index) in oprList"
              @click.stop.prevent="checkPlat(item,index)"
              @dblclick.stop.prevent="dbClickPlat(item)" :key="index">
            {{item.platformName}}
          </li>
        </ul>
        <div slot="footer" class="am-text-right">
          <cc-button type="primary" @click.prevent="sureOpr" :disabled="oprIndex<0">下一步</cc-button>
        </div>
      </Modal>
      <Modal v-model="isBrandShow" width="500px" :closable="false" :maskClosable="false">
        <div slot="header" class="choose-modal-title">请选择品牌</div>
        <ul>
          <li class="item" :class="brandIndex === index ? 'checked':''" v-for="(item,index) in brandList"
              @click.stop.prevent="checkBrand(item,index)"
              @dblclick.stop.prevent="dbClickBrand(item)" :key="index">
            {{item.brandName}}
          </li>
        </ul>
        <div slot="footer" class="am-text-right">
          <cc-button type="primary" @click.prevent="backOpr">上一步</cc-button>
          <cc-button type="primary" @click.prevent="sureBrand" :disabled="brandIndex<0">下一步</cc-button>
        </div>
      </Modal>
      <!--<cc-modal title="请选择运营商" :show="isOprShow" :width="'500px'" :isNeedCloseBtn="false" onselectstart="return false">-->
      <!--<div slot="modal-body">-->
      <!--<ul>-->
      <!--<li class="item" :class="oprIndex === index ? 'checked':''" v-for="(item,index) in oprList"-->
      <!--@click.stop.prevent="checkPlat(item,index)"-->
      <!--@dblclick.stop.prevent="dbClickPlat(item)" :key="index">-->
      <!--{{item.platformName}}-->
      <!--</li>-->
      <!--</ul>-->
      <!--</div>-->
      <!--<div slot="modal-footer">-->
      <!--<div class="btns">-->
      <!--<cc-button type="primary" @click.prevent="backOpr">上一步</cc-button>-->
      <!--<cc-button type="primary" @click.prevent="sureBrand" :disabled="brandIndex<0">下一步</cc-button>-->
      <!--</div>-->
      <!--</div>-->
      <!--</cc-modal>-->
      <!--<cc-modal title="请选择品牌" :show="isBrandShow" :width="'500px'" :isNeedCloseBtn="false" onselectstart="return false">-->
      <!--<div slot="modal-body">-->
      <!--<ul>-->
      <!--<li class="item" :class="brandIndex === index ? 'checked':''" v-for="(item,index) in brandList"-->
      <!--@click.stop.prevent="checkBrand(item,index)"-->
      <!--@dblclick.stop.prevent="dbClickBrand(item)" :key="index">-->
      <!--{{item.brandName}}-->
      <!--</li>-->
      <!--</ul>-->
      <!--</div>-->
      <!--<div slot="modal-footer">-->
      <!--<div class="btns">-->
      <!--<cc-button type="primary" @click.prevent="backOpr">上一步</cc-button>-->
      <!--<cc-button type="primary" @click.prevent="sureBrand" :disabled="brandIndex<0">下一步</cc-button>-->
      <!--</div>-->
      <!--</div>-->
      <!--</cc-modal>-->
    </div>
  </div>
</template>

<script>
  import {getUrlParameter} from '@/utils/assist'
  // import Modal from '@/components/Cc-Modal'
  import Button from '@/components/Cc-Button'
  import LoadingBox from '@/components/Cc-Loading';
  import Modal from '@/components/Modal'
  function initialize() { 
   console.log('地图加载完成')
  } 
  window.initialize = initialize

  export default {
    layout: 'default',
    name: 'choose',
    data() {
      let urlObj = getUrlParameter();
      return {
        urlObj,
        brandPhone: urlObj.storePhone
        , platformKey: ""
        , oprList: []
        , oprIndex: -1
        , brandId: 0
        , brandInfo: {}
        , brandList: []
        , brandIndex: -1
        , isOprShow: true
        , isBrandShow: false
        , isLoading: true
      };
    },
    created() {
      //获取运营商数据
      this.getOpr()
    },
    mounted() {
    },
    methods: {
      getOpr() {
        let that = this;
        this.server
          .get({
            name: "getOprList",
            data: {
              // content:{
              phone: this.urlObj.storePhone,
              enableType:true,
              platformKey: this.urlObj.platformKey || null // 只有国际版使用
              // }
            }
          })
          .then(result => {
            if (result.status === 1 && result.data) {
              this.oprList = result.data;
              if (result.data.length === 1) { // 若只有一个运营商，则直接进入品牌列表选择
                that.dbClickPlat(result.data[0])
              }
            } else if (result.status === 2) {
              alert(result.msg)
            }
          })
      },
      getBrand() {
         this.server
          .get({
            name: "getTencentMapKey",
            data: {} })
          .then(result => {
            console.log(result,'resultaa')
            let tencentMapKey = '';
            if(result&&result.status==1&&result.data){
              if(result.data.type==1){
                var _casp = document.createElement("script");
                _casp.src =  "//map.qq.com/api/js?v=2.exp&key="+ result.data.key+'&libraries=place,service&callback=initialize'
                _casp.type = "text/javascript";
                var s = document.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(_casp, s);
                tencentMapKey = result.data.key
              } else {
                if(result.data.key=='aa3b85fcb070c2afd2df4e76e4f4f813'){
                  window._AMapSecurityConfig = {
                      securityJsCode: result.data.secretKey,
                  }
                }
                var _casp = document.createElement("script");
                _casp.src =  "//webapi.amap.com/maps?v=1.4.12&key="+ result.data.key+'&plugin=AMap.Autocomplete&plugin=AMap.DistrictSearch'
                _casp.type = "text/javascript";
                var s = document.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(_casp, s);
              }
              this.$store.dispatch('booking/user/update', {tencentMapKey});
            }

          })
        // 获取品牌列表
        let that = this;
        this.server.setPublicData({platformKey: this.platformKey});
        this.server
          .get({
            name: "getBrandList",
            data: {
              platformKey: this.urlObj.platformKey ? this.platformKey : null, // 只有国际版使用
              // content:{
              "phone": this.urlObj.storePhone
              //   }
            }
          })
          .then(result => {
            if (result.status === 1 && result.data.brandList) {
              this.brandList = result.data.brandList;
              if (result.data.brandList.length === 1) { // 若只有一个运营商，则直接进入品牌列表选择
                that.dbClickBrand(result.data.brandList[0])
              }
            } else if (result.status === 2) {
              alert(result.msg)
            }
          })
      },
      checkPlat(item, index) {
        // console.log('点击运营商')
        this.oprIndex = index;
        this.platformKey = item.platformKey
      },
      dbClickPlat(item) {
        this.platformKey = item.platformKey;
        this.isOprShow = false;
        this.isBrandShow = true;
        this.brandIndex = -1;
        // 存放在store 选中营运商
        this.$store.dispatch('booking/user/update', {
          oprInfo: item
        });
        //由于项目中Vuex的设计原因，导致无法在组件外使用store，所以暂时使用window来从储存运营商信息
        console.log(item);
        window.oprInfo = item;
        window.currency = item.currencySymbol || '';
        this.getBrand()
      },
      sureOpr() {
        let {oprList, oprIndex} = this;
        this.dbClickPlat(oprList[oprIndex])
      },
      showBrandList() {
      },
      checkBrand(item, index) {
        this.brandIndex = index;
        this.brandId = item.brandId;
        this.brandInfo = item
        // console.log('点击')
      }
      , dbClickBrand(item) {
        // 点击对应品牌
        let brandId = item.brandId;
        this.brandId = brandId;
        this.brandName = item.name;
        this.brandInfo = item;
        // 存放在store
        this.$store.dispatch('booking/user/update', {
          brandInfo: item,
          isChoose: true
        });
        this.isBrandShow = false;
        this.brandIndex = -1;
        this.isLoading = false;
        this.isOprShow = false;
        this.findStoreByBrandIdAndPhone({brandId, storePhone: this.urlObj.storePhone}).finally(() => {
          setTimeout(() => {
            this.$router.push('/customer')
          })
        })
      },
      findStoreByBrandIdAndPhone({brandId, storePhone}) {
        return this.server
          .get({
            name: "findStoreByBrandIdAndPhone",
            data: {
              brandId,
              phone: storePhone
            }
          }).then((res) => {
            let data = res.data;
            if (data) {
              let businessType = data.businessType,
                [longitude, latitude] = data.coordinate || [0, 0];
              if (businessType.length) {
                // 有业务存在返回
                this.$store.commit('booking/user/update', {
                  storeId: data.storeId,
                  sendType: businessType[0],
                  isBrandStoreOne: true,
                  longitude,
                  latitude
                })
              }
            }
          })
      }
      , sureBrand() {
        let {brandList, brandIndex} = this;
        this.dbClickBrand(brandList[brandIndex])
      }
      , backOpr() {
        this.isOprShow = true;
        this.isBrandShow = false;
      }
      , enterCC() {

      }
    },
    beforeDestroy() {
      this.isOprShow = false;
      this.isBrandShow = false;
    },
    components: {
      Modal: Modal,
      ccButton: Button
      , ccLoadingBox: LoadingBox
    }
  }
</script>
<style scoped>
  .choose-modal-title {
    margin: 0;
    line-height: 1.4;
    font-size: 20px;
    color: #59738c;
  }

  .btns {
    padding: 0 15px 15px;
    text-align: right;
  }

  li.item {
    height: 30px;
    line-height: 30px;
    text-indent: 4px;
    font-size: 14px;
  }

  li.item:hover {
    cursor: pointer;
    background-color: #d1dfe3;
  }

  li.checked {
    background-color: #b0c7cd;
  }
</style>




// WEBPACK FOOTER //
// pages/choose.vue